function Footer() {
  return (
    <footer className="w-full mt-auto  border-black flex justify-between items-center px-6 py-4">
      {/* <img src={logo} className="w-[15%]" alt="logo" /> */}
      {/* <p className="text-sm">© Tectigon all rights reserved</p> */}
    </footer>
  );
}

export default Footer;
